export default __webpack_public_path__ + "static/media/financing_download_rectangle.47b2dc78.png";